import { ProjectName } from "@org-avp/avp-avengers-project-service-api";

export const stringifyProjectName = (projectName?: ProjectName, separator = " "): string => {
  if (!projectName) {
    return "";
  }
  const { projectCode, productIds, bodyTypes } = projectName;
  return [projectCode, productIds.join(separator), bodyTypes.join(separator)].join(separator);
};
